import { createFileRoute, redirect } from '@tanstack/react-router';
import TradeReference from '../../../../components/pages/trade-reference';
import { getTradeReferenceData } from '../../../../api/trade-references/get-trade-reference-data';
import {
  ApiError, isNotFoundError, NotFoundErrorCode,
} from '../../../../utils/errors';
import { SurveySettings } from '../../../../types';

interface TradeReferenceLoaderParams {
  params: { accountSlug: string; trackingId: string };
}

export type TradeReferenceLoaderResponse =
  | { type: 'success', settings: SurveySettings }
  | { type: 'error', error: ApiError };

export const Route = createFileRoute('/trade-references/$accountSlug/$trackingId/')({
  loader: async ({
    params: { accountSlug, trackingId },
  }: TradeReferenceLoaderParams): Promise<TradeReferenceLoaderResponse> => {
    try {
      const { settings } = await getTradeReferenceData(accountSlug, trackingId);

      return {
        type: 'success',
        settings,
      };
    } catch (error) {
      if (isNotFoundError(error) && error.code === NotFoundErrorCode.SettingsNotFound) {
        throw redirect({ to: '/' });
      }

      if (isNotFoundError(error) && error.code === NotFoundErrorCode.TradeReferenceNotFound) {
        return {
          type: 'error',
          error,
        };
      }

      throw error;
    }
  },
  component: TradeReference,
});
